<template>
  <div class="wrapper">
    <PageTitle :value="$t('nav.USER_PERSON')" />
    <Search :label="$t('lookupPlaceholder.PERSON')" />
    <v-app>
      <FilterList />
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="dataList"
        :options.sync="sortOptions"
        :hide-default-footer="true"
        :server-items-length="dataList.length"
        @click:row="handleClickRow"
      >
        <template #[`item.is_active`]="{ item }">
          <TableIcon :value="item.is_active" />
        </template>
        <template #[`item.interested_co`]="{ item }">
          <span class="array_td">
            {{ JSON.stringify(item.interested_co.map(element => element.name)) }}
          </span>
        </template>
        <template #[`item.skills`]="{ item }">
          <span class="array_td">
            {{ JSON.stringify(item.skills.map(element => element.name)) }}
          </span>
        </template>
      </v-data-table>
      <Pagination />
      <Excel @click="fetchExcelFile" />
    </v-app>
  </div>
</template>

<script>
import table from "@/mixins/table"
import excel from "@/mixins/excel"
import param from "@/mixins/param"
import sort from "@/mixins/sort"
import { MENU, CATEGORY, } from "@/constants/mapVarNames"
import { getExcelDataByUsersCategory, } from "@/api/exportExcel"
import TableIcon from "@/components/lookup/TableIcon"

export default {
  components: { TableIcon, },
  mixins: [table, excel, param, sort],
  data() {
    return {
      filterItems: {
        gender: null,
        is_active: null,
      },
      headers: [
        {
          text: this.$t("headers.ID"),
          value: "id",
          sortable: true,
        },
        {
          text: this.$t("headers.USERNAME"),
          value: "username",
          sortable: true,
        },
        {
          text: this.$t("headers.BIRTHDAY"),
          value: "birthday",
          sortable: true,
        },
        {
          text: this.$t("headers.GENDER"),
          value: "gender",
          sortable: false,
        },
        {
          text: this.$t("headers.EXPERIENCE"),
          value: "experience",
          sortable: false,
        },
        {
          text: this.$t("headers.EDUCATION"),
          value: "education",
          sortable: false,
        },
        {
          text: this.$t("headers.MAJOR"),
          value: "major",
          sortable: false,
        },
        {
          text: this.$t("headers.POSITION"),
          value: "position",
          sortable: false,
        },
        {
          text: this.$t("headers.INTERESTED_CO"),
          value: "interested_co",
          sortable: false,
        },
        {
          text: this.$t("headers.SKILLS"),
          value: "skills",
          sortable: false,
        },
        {
          text: this.$t("headers.IS_ACTIVE"),
          value: "is_active",
          sortable: false,
        },
        {
          text: this.$t("headers.DATE_JOINED"),
          value: "date_joined",
          sortable: false,
        }
      ],
      sortOptions: {},
    }
  },
  watch: {
    sortOptions: {
      handler(value) {
        if (value.sortBy[0]) {
          this.$_sort_handleSort(value.sortBy[0])
        }
      },
      deep: true,
    },
  },
  created() {
    this.$store.commit("SET_LOOKUP_CATEGORY", { menu: MENU.users, category: CATEGORY.person, })
    this.$store.dispatch("setFilterItems", this.filterItems)
    this.$store.dispatch("fetchLookupData")
  },
  methods: {
    async fetchExcelFile() {
      try {
        const params = this.$_param_createParams()
        const response = await getExcelDataByUsersCategory({ category: CATEGORY.person, params, })

        this.$_excel_downloadFile(response, CATEGORY.person)
      } catch (error) {
        this.$store.dispatch("setError", error)
      }
    },
    handleClickRow(rowData) {
      const dataId = rowData.id

      this.$router.push({ name: "personDetail", params: { id: dataId, }, })
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
